import React from "react";
import { useNavigate } from "react-router-dom";
import { Zap, Sparkles, Bell, ArrowRight } from "lucide-react";
import { AppHeader } from "../components/AppHeader";

const SEEN_KEY = "myfleet_welcome_seen";

export function hasSeenWelcome() {
  return localStorage.getItem(SEEN_KEY) === "true";
}

export default function Welcome() {
  const navigate = useNavigate();

  const onStart = () => {
    localStorage.setItem(SEEN_KEY, "true");
    navigate("/login", { replace: true });
  };

  return (
    <div
      data-testid="welcome-screen"
      className="mf-screen"
      style={{
        background: "var(--mf-brand)", color: "#fff",
        paddingTop: "env(safe-area-inset-top)",
      }}
    >
      <AppHeader variant="light" background="brand" clickable={false} />

      <div className="mf-anim-in" style={{
        flex: 1, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: 12,
        padding: "16px 24px",
      }}>
        <div style={{
          color: "rgba(255,255,255,0.72)", fontSize: 18, fontWeight: 500,
          letterSpacing: 0.2, textAlign: "center",
        }}>
          Votre flotte, sans effort.
        </div>
      </div>

      <div className="mf-anim-in" style={{
        padding: "8px 32px", display: "flex", flexDirection: "column", gap: 18,
        maxWidth: 480, width: "100%", margin: "0 auto",
      }}>
        <Feature icon={<Zap size={18} color="#fff" />} title="Rapide" subtitle="Ajoutez une intervention en moins de 20 secondes." />
        <Feature icon={<Sparkles size={18} color="#fff" />} title="Intelligent" subtitle="Scannez une facture, l'IA remplit le formulaire." />
        <Feature icon={<Bell size={18} color="#fff" />} title="Zéro oubli" subtitle="Alertes automatiques par date et kilométrage." />
      </div>

      <div style={{
        padding: "20px 24px calc(20px + env(safe-area-inset-bottom))",
        maxWidth: 480, margin: "0 auto", width: "100%",
      }}>
        <button
          onClick={onStart}
          data-testid="welcome-start-button"
          style={{
            width: "100%", display: "inline-flex", alignItems: "center",
            justifyContent: "center", gap: 10,
            background: "#fff", color: "var(--mf-brand)",
            padding: "16px 24px", borderRadius: 999, border: "none",
            fontSize: 16, fontWeight: 700, cursor: "pointer",
          }}
        >
          Commencer
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
}

function Feature({ icon, title, subtitle }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 14 }}>
      <div style={{
        width: 36, height: 36, borderRadius: 10,
        background: "rgba(255,255,255,0.12)",
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0,
      }}>
        {icon}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>{title}</div>
        <div style={{ fontSize: 13, color: "rgba(255,255,255,0.62)", marginTop: 2, lineHeight: 1.4 }}>
          {subtitle}
        </div>
      </div>
    </div>
  );
}
